/* global React, Icon */

function buildPersonalFinanceOnboardingStages({ doneSrc, inviteId, plumSrc, privateModes, setPrivateModes }) {
  return [
    <div className="ob-hero" key="privat">
      <img className="ob-hero-plum" src={plumSrc} alt="SuperPlumma" />
      <div className="ob-eyebrow">{t('pob.personal')}</div>
      <h2 className="ob-title">{t('sharedText.onb.createPersonal')}</h2>
      <p className="ob-lead">{t('sharedText.onb.createPersonalHelp')}</p>
    </div>,
    <div key="privat-goals">
      <div className="ob-eyebrow">{t('pob.step1Eyebrow')}</div>
      <h2 className="ob-title">{t('pob.step1Title')}</h2>
      <p className="ob-lead">{t('pob.step1Lead')}</p>
      <div className="ob-choose">{[
        ['personlig', t('pob.personal'), t('pob.personalDesc')],
        ['familie', t('pob.family'), t('pob.familyDesc')],
      ].map(([key, title, text]) => <button type="button" key={key} disabled={inviteId && key === 'familie'} className={`ob-choose-card${privateModes.includes(key) ? ' is-selected' : ''}`} onClick={() => setPrivateModes((current) => {
        if (inviteId && key === 'familie') return current;
        const next = current.includes(key) ? current.filter((item) => item !== key) : [...current, key];
        return next.length ? next : [key];
      })}>
        <span className="ob-choose-name">{title}</span><span className="ob-choose-sub">{text}</span>
      </button>)}</div>
    </div>,
    <div key="privat-privacy">
      <div className="ob-eyebrow">{t('pob.step2Eyebrow')}</div>
      <h2 className="ob-title">{t('pob.step2Title')}</h2>
      <div className="ob-fields">
        <div className="ob-warning"><Icon name="lock" size={17} /><span>{t('sharedText.onb.noBankData')}</span></div>
        <div className="ob-warning"><Icon name="users" size={17} /><span>{t('pob.familyLinkNote')}</span></div>
      </div>
    </div>,
    <div className="ob-hero" key="privat-ready">
      <img className="ob-hero-plum" src={doneSrc} alt="SuperPlumma" />
      <div className="ob-eyebrow">{t('pob.readyEyebrow')}</div>
      <h2 className="ob-title">{t('sharedText.onb.createPersonal')}</h2>
      <p className="ob-lead">{t('pob.readyLead')}</p>
      {inviteId && <div className="ob-warning"><Icon name="users" size={17} /><span>{t('pob.inviteNote')}</span></div>}
    </div>,
  ];
}

window.buildPersonalFinanceOnboardingStages = buildPersonalFinanceOnboardingStages;
